"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var _styleConsts = require("../../utils/styleConsts");

var styles = function styles() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("margin:0;strong{font-weight:", _styleConsts.font.weight.bold, ";}")
  );
};

var _default = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("p", {
  target: "css-asamz90"
})(styles));

exports.default = _default;